import axios from 'axios'
import { ApiConfig } from '../../../config/api'
import { ValidatePositionResponse, StockBySkuResponse, GetFirstPositionResponse, StockKeepingUnitDunInfo } from '../types'
import { eTypeRelocatePosition } from '../../../enums/eTypeRelocatePosition'
import { ApiResponse } from '../../../typings/ApiResponse'

/**
 * API service for relocate operations
 * Centralizes all API calls related to product relocation
 */
export class RelocateApiService {
  /**
   * Validates if a position is valid for a given SKU and product origin
   */
  static validateOriginPosition(positionCode: string, sku: string, productOriginId: number) {
    return axios.get<ValidatePositionResponse>(`${ApiConfig.RelocateApi}/ValidatePosition`, {
      params: { positionCode, sku, productOriginId, typeRelocatePosition: eTypeRelocatePosition.Origin }
    })
  }

  /**
   * Gets stock information for a SKU in a specific position
   */
  static getStockByPosition(positionCode: string, sku: string, productOriginId: number) {
    return axios.get<StockBySkuResponse[]>(`${ApiConfig.RelocateApi}/GetStockBySku`, {
      params: { skuEan: sku, productOriginId, positionCode }
    })
  }

  /**
   * Validates if a destination position is valid for a given SKU and product origin
   */
  static validateDestinyPosition(positionCode: string, sku: string, productOriginId: number) {
    return axios.get<ValidatePositionResponse>(`${ApiConfig.RelocateApi}/ValidatePosition`, {
      params: { positionCode, sku, productOriginId, typeRelocatePosition: eTypeRelocatePosition.Destiny }
    })
  }

  /**
   * Resuelve un código DUN a su SKU base, unidades equivalentes, unidad de medida
   * y marca (productOriginId).
   *
   * El endpoint es paginado y el índice sobre Dun es único, así que devuelve 0 o 1
   * item: página vacía equivale a "DUN inexistente".
   */
  static resolveDun(dun: string) {
    return axios.get<ApiResponse<StockKeepingUnitDunInfo>>(`${ApiConfig.StockKeepingUnitDun}`, {
      params: { dun, pageIndex: 0, pageSize: 1 }
    })
  }

  /**
   * Gets the first available position of a specific type in a zone
   */
  static getFirstPositionByType(zoneId: number, typePositionId: number) {
    return axios.get<GetFirstPositionResponse>(`${ApiConfig.PositionApi}`, {
      params: {
        pageIndex: 0,
        pageSize: 1,
        zoneId,
        typepositionId: typePositionId
      }
    })
  }
}